import http from './http-common';
import axios from 'axios';
import storage from '../factory/StorageFactory';

//SME Api 
const getStatus = (stateId, refNo) => {  
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
          Pragma: 'no-cache'  //IE11
        }
    }
  
//  return axios.get(`http://localhost:3000/NSSubmission.json`); 
  return http.get(`/api/v1/SMEDL/GetStatus/${stateId}/${refNo}`,headerParams); 
};

const getStatusEnquiry = (stateId, refNo) => {  
  let headerParams ={
      headers: {
        "Content-Type": "application/json",
        'Authorization':"Maybank" + " " + storage.getToken(),
        Pragma: 'no-cache'  //IE11
      }
  }
  // return axios.get(`http://localhost:3000/NSSubmission.json`); 
  return http.get(`/api/v1/SMEDL/GetStatusEnquiry/${stateId}/${refNo}`,headerParams); 
};

const cancel = (refNo, uen) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
          Pragma: 'no-cache'  //IE11
        }
    }

    let params = {
      "refNo":refNo,
      "uen":uen
    }

    return http.put(`/api/v1/SMEDL/putLoanCancel`,params,headerParams);
}

const validateBoardMeeting = (refNo,uen,bmDate) => {
  let headerParams ={
    headers: {
      "Content-Type": "application/json",
      'Authorization':"Maybank" + " " + storage.getToken(),
      Pragma: 'no-cache'  //IE11
    }
  }
 
return http.get(`/api/v1/SMEDL/ValidateBoardMeeting/${refNo}/${uen}/${bmDate}`,headerParams); 
}

const getBoardMeeting = (refNo) => {
  let headerParams ={
    headers: {
      "Content-Type": "application/json",
      'Authorization':"Maybank" + " " + storage.getToken(),
      Pragma: 'no-cache'  //IE11
    }
  }
  return http.get(`/api/v1/SMEDL/GetBoardMeeting/${refNo}`,headerParams); 
}

const putBoardMeeting = (refNo,params) => {
  let headerParams ={
      headers: {
        "Content-Type": "application/json",
        'Authorization':"Maybank" + " " + storage.getToken(),
        Pragma: 'no-cache'  //IE11
      }
  }
 
  return http.put(`/api/v1/SMEDL/BoardMeeting/${refNo}`, params, headerParams);
}

const getLetterOffer = (refNo) => {  
  let headerParams ={
      headers: {
        "Content-Type": "application/json",
        'Authorization':"Maybank" + " " + storage.getToken(),
        Pragma: 'no-cache'  //IE11
      }
  }
  return http.get(`/api/v1/SMEDL/GetLetterOffer/${refNo}`,headerParams); 
};

const getDocumentStatus = (refNo) => {  
  let headerParams ={
      headers: {
        "Content-Type": "application/json",
        'Authorization':"Maybank" + " " + storage.getToken(),
        Pragma: 'no-cache'  //IE11
      }
  }
  return http.get(`/api/v1/SMEDL/GetUploadDetails/${refNo}`,headerParams); 
};


export default {
    getStatus,
    getStatusEnquiry,
    cancel,
    getLetterOffer,
    validateBoardMeeting,
    putBoardMeeting,
    getBoardMeeting,
    getDocumentStatus
}